// extracted by mini-css-extract-plugin
export default {"DialogOverlay":"OJzUDzyPpW","DialogOverlayRoot":"EExgw8en_l","DialogOverlayContent":"svtHTcQuhO","DialogClose":"CdVxAc9D6e"};